var version = {
    "name":      "dativery",
    "buildDateCode": "20251128-195701",
    "buildDate": "Fri Nov 28 2025 19:57:01 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251128-195701",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;